const scrollTo = (href) => {
  let $el = document.querySelector(href)
  if(!$el) return

  let $menu = $('.main-menu'),
      t = $el.offsetTop,
      h = $menu.height()

  $('html, body').animate({
    scrollTop: t - h
  }, 250)
}

const Anchor = () => {
  let $anchors = document.querySelectorAll('[anchor]')
  if($anchors.length === 0) return

  $anchors.forEach(($anchor) => {
    $anchor.addEventListener('click', (e) => {
      e.preventDefault()
      // --
      scrollTo($anchor.getAttribute('href'))
    })
  })

}

export default Anchor
